import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AboutUs from './pages/AboutUs';
import Login from './pages/login/Login';
import Feedback from './pages/feedBack/Feedback';
import CostTracker from './pages/costTracker/CostTracker';
import SelfHarm from './pages/selfHarm/SelfHarm';
import Layout from './components/layout/Layout';
import ForgotPassword from './pages/forgotPassword/ForgotPassword';
import SubscribeUnsubscribe from './components/EmailPreferencesPage/SubscribeUnsubscribe';
import SupportPage from './pages/supportPage/SupportPage';
import EmailVerification from './pages/EmailVerification';
import AccountDeletion from './pages/AccountDeletion';
import TermsOfService from './pages/TermsOfService';
import EndUserAgreement from './pages/EndUserAgreement';

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/subscribe" element={<SubscribeUnsubscribe />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route
            path="/verify-email/:userId/:token?"
            element={<EmailVerification />}
          />
          <Route
            path="/admin/feedback"
            element={
              <Layout>
                <Feedback />
              </Layout>
            }
          />
          <Route
            path="/admin/cost-tracker"
            element={
              <Layout>
                <CostTracker />
              </Layout>
            }
          />
          <Route
            path="/admin/self-harm"
            element={
              <Layout>
                <SelfHarm />
              </Layout>
            }
          />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/end-user-agreement" element={<EndUserAgreement />} />
        </Routes>
        {/* <Footer /> */}
      </div>
    </Router>
  );
}

export default App;
